import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "stopchlamas_session_token";

export const getStoredToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch (_e) { return null; }
};
export const setStoredToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (_e) { /* noop */ }
};

export const api = axios.create({
  baseURL: API,
  // Note: we deliberately do NOT set `withCredentials: true`. The backend
  // also sets `Access-Control-Allow-Origin: *`, which is incompatible with
  // credentialed requests (the browser would reject the response).
  // Instead we send the session token via Authorization: Bearer header
  // (set by the interceptor below). This works cross-origin without any
  // CORS-with-credentials gymnastics.
});

// Send the stored session token via Authorization header on every request.
// This is the cross-origin-safe path: browsers may block third-party cookies
// when the app is served on a custom domain (e.g. stopchlamas.lt) while the
// API lives on a different domain. The backend already accepts both
// `session_token` cookie and `Authorization: Bearer <token>` header.
api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fileUrl = (path) => `${API}/files/${path}`;
